// snowfall.js - neige ultra réaliste du 1er décembre au 5 janvier
(function() {
    const today = new Date();
    const month = today.getMonth(); // 0 = janvier, 11 = décembre
    const day = today.getDate();

    // Actif du 1er décembre au 5 janvier
    if (!((month === 11) || (month === 0 && day <= 5))) return;

    const snowContainer = document.createElement('div');
    snowContainer.style.position = 'fixed';
    snowContainer.style.top = '0';
    snowContainer.style.left = '0';
    snowContainer.style.width = '100%';
    snowContainer.style.height = '100%';
    snowContainer.style.pointerEvents = 'none';
    snowContainer.style.zIndex = '9999';
    document.body.appendChild(snowContainer);

    function random(min, max) {
        return Math.random() * (max - min) + min;
    }

    function createSnowflake() {
        const snowflake = document.createElement('div');
        snowflake.textContent = '❄';
        snowflake.style.position = 'absolute';
        snowflake.style.top = '-30px';
        snowflake.style.left = random(0, window.innerWidth) + 'px';

        // Taille aléatoire pour plus de réalisme
        snowflake.style.fontSize = random(5, 20) + 'px';

        // Opacité aléatoire
        snowflake.style.opacity = random(0.3, 0.9);

        // Couleur aléatoire blanc / gris clair
        snowflake.style.color = Math.random() < 0.7 ? 'white' : '#f0f0f0';

        snowflake.style.userSelect = 'none';
        snowflake.style.pointerEvents = 'none';

        snowContainer.appendChild(snowflake);

        // Vitesse et déplacement horizontal aléatoire
        const duration = random(4000, 12000);
        const horizontalShift = random(-50, 50);

        snowflake.animate([
            { transform: 'translate(0, 0)' },
            { transform: `translate(${horizontalShift}px, ${window.innerHeight + 30}px)` }
        ], {
            duration: duration,
            iterations: 1,
            easing: 'linear'
        });

        setTimeout(() => snowflake.remove(), duration);
    }

    // Densité réduite sur mobile
    const intervalTime = window.innerWidth < 768 ? 350 : 150;
    setInterval(createSnowflake, intervalTime);
})();
